export function getCacheaccess ({ state, commit }, { search, page }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/cacheaccess', { params: { search, page } })
      .then((response) => {
        if (response.data.cacheaccess) {
          commit('setCacheaccess', response.data.cacheaccess)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createCacheaccess ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/cacheaccess')
      .then((response) => {
        if (response.data.cacheaccess) {
          commit('setCacheaccess', response.data.cacheaccess)
        }
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function updateCacheaccess ({ state, commit }, accountkey) {
  return new Promise((resolve, reject) => {
    if (accountkey) {
      axiosInstance.put('/v1/cacheaccess/' + accountkey)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No accountkey'))
    }
  })
}

export function deleteCacheaccess ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.delete('/v1/cacheaccess/all')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
